import { ChangeDetectorRef, Component, inject } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community';

@Component({
    standalone: false,
    selector: 'por-ag-grid-custom-header',
    templateUrl: './ag-grid-header.component.html',
    styleUrls: ['./ag-grid-header.component.scss']
})
export class AgGridCustomHeaderComponent {
    private readonly cdr = inject(ChangeDetectorRef);

    params!: IHeaderParams & { subTitle?: string; isShowTooltip?: boolean; tooltipTitle?: string; tooltipContent?: string };
    overlayStates = false;

    agInit(params: IHeaderParams & { subTitle?: string; isShowTooltip?: boolean; tooltipTitle?: string; tooltipContent?: string }) {
        this.params = params;
    }

    toggleOverlay() {
        this.overlayStates = !this.overlayStates;
        this.cdr.detectChanges();
    }
}
